import { useInfiniteQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { envChangeType, envType, langMap } from "../../../plugins/utils";
import activityTypeIdEnum from "../enumeration/activityTypeIdEnum";
import { apiGetPromotionList } from "../service";

export const useGetPromotionList = ({ value, typeId, groupId, page_size, options }) => {
  let params = {};
  switch (value) {
    case activityTypeIdEnum.ALL:
      break;
    default:
      params = {
        promotion_type_group: groupId,
        promotion_type_id: typeId,
      };
      break;
  }
  return useInfiniteQuery(
    [queryKey.PROMOTION_LIST, value],
    ({ pageParam = 1 }) =>
      apiGetPromotionList({ params, page_size, page: pageParam }).then((res) => {
        const promotions = {
          ...res.data.data,
          data: res.data.data.data
            .map((_promo) => {
              if (_promo.promotion_type === "PRCP") {
                return {
                  ..._promo,
                  start_time: undefined,
                  end_time: undefined,
                  img_url: `/images/activity/secretNumber/${langMap(["zh", "en", "bn"])}/${
                    _promo.promotion_type
                  }.png`,
                };
              }
              if (_promo.promotion_type === "PRBR") {
                return {
                  ..._promo,
                  start_time: undefined,
                  end_time: undefined,
                  img_url: `/images/activity/betRebate/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${langMap(["zh", "en"])}/${_promo.promotion_type}.png`,
                  fallback_url: `/images/activity/betRebate/${langMap(["zh", "en"])}/${_promo.promotion_type}.png`,
                };
              }
              return _promo;
            })
            .filter((_promo) => _promo.status === 1 && _promo.promotion_type !== "PRBR"),
        };
        if (
          value === activityTypeIdEnum.ALL &&
          envChangeType("REACT_APP_SHOW_DAILY_PROMO", envType.BOOLEAN)
        ) {
          return {
            ...promotions,
            data: [
              {
                id: -66,
                img_url: `/images/activity/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/banner.jpg`,
                start_time: undefined,
                end_time: undefined,
                promotion_type: `DAILY_PROMO`,
              },
              ...promotions.data,
            ],
          };
        }
        return promotions;
      }),
    {
      ...options,
    },
  );
};
